<template>
  <div :class="getSideDrawer ? 'side-drawer' : 'side-drawer-collapsed'">
    <div class="menu-area">
      <div class="menus">
        <List
          to="/dashboard"
          :label="$t('adminNav.dashboard')"
          icon="dashboard"
          id="dashboard-nav"
        />
        <List
          to="/customers"
          label="Customers"
          icon="users"
          id="customer-nav"
          v-if="user.role === 'admin'"
        />
        <List
          :to="`/customers/${user.uid}`"
          label="Customers"
          icon="users"
          id="customer-nav"
          v-else
        />
        <List
          to="/users"
          label="Users"
          icon="users"
          id="users-nav"
          v-if="user.role === 'admin'"
        />
         <List
          to="/vehicles"
          label="Vehicles"
          icon="car"
          id="users-nav"
          v-if="user.role === 'admin'"
        />
      </div>
      <div class="mb-5">
        <button class="logout-button" @click="logoutUser" id="logout-user">
          <span v-if="getSideDrawer">{{ $t("adminNav.logout") }}</span>
          &nbsp;&nbsp;<i class="fa fa-sign-out"></i>
        </button>
        <div class="text-left mt-3 text-muted">
          <small class="ml-1 text-center"
            >{{ $t("adminNav.version") }} {{ versionCode }}</small
          >
        </div>
      </div>
    </div>
    <button
      :class="getSideDrawer ? 'toggle-sidebar' : 'toggle-sidebar-rotated'"
      @click="toggleDrawer"
    >
      <i class="fa fa-chevron-left"></i>
    </button>
  </div>
</template>

<script>
import List from "@/components/List";
import store from "../modules/store";
import { version } from "../../package.json";
import { mapGetters } from "vuex";

export default {
  components: {
    List
  },
  methods: {
    toggleDrawer() {
      store.dispatch("toggleSideDrawer");
    },
    logoutUser() {
      if (this.$route.meta.title === "Create job") {
        this.$root.toast("Job is in progress. please before logout");
        return;
      }
      this.$root.logout();
    }
  },
  computed: {
    ...mapGetters({
      getSideDrawer: "getSideDrawer",
      planId: "getPlanId",
      user: "getUser"
    }),
    versionCode() {
      return version;
    }
  }
};
</script>

<style scoped>
.side-drawer {
  width: 280px;
  border-right: 1px solid var(--primary-color);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  margin-top: 80px;
  padding: 0 30px;
  transition: all 0.3s ease;
}
.side-drawer-collapsed {
  width: 75px;
  border-right: 1px solid var(--primary-color);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  margin-top: 80px;
  padding: 0 15px;
  transition: all 0.3s ease;
}
.menus {
  padding-top: 20px;
}
.toggle-sidebar {
  position: absolute;
  right: -15px;
  bottom: 75px;
  background: var(--primary-color);
  outline: none;
  border: 1px solid var(--white);
  border-radius: 15px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(0);
  transition: transform 0.3s 0.3s ease;
  color: #fff;
}
.toggle-sidebar-rotated {
  position: absolute;
  right: -15px;
  bottom: 75px;
  background: var(--primary-color);
  outline: none;
  border: 1px solid var(--white);
  border-radius: 15px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(180deg);
  transition: transform 0.3s 0.3s ease;
  color: #fff;
}
.menu-area {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.logout-button {
  color: var(--secondary-color);
  background: none;
  outline: none;
  border: none;
  white-space: nowrap;
}

@media screen and (max-width: 750px) {
  .side-drawer,
  .side-drawer-collapsed {
    display: none;
  }
}
</style>
